import Banner from '@/components/Banner';
import Body from '@/components/Body';
import Capabilities from '@/components/Capabilities';
import CTAList from '@/components/CTAList';
import ClientLogoBar from '@/components/ClientLogoBar/ClientLogoBar';
import CaseStudyTeam from '@/components/CaseStudyTeam';
import CollapsibleItems from '@/components/CollapsibleItems';
import ColumnsLayout from '@/components/ColumnsLayout';
import FiftyFifty from '@/components/FiftyFifty';
import FlexRow from '@/components/FlexRow';
import Fold from '@/components/Fold';
import Grid from '@/components/Grid';
import HubspotFormBlock from '@/components/HubspotFormBlock';
import Talents from '@/components/Talents';
import Testimonials from '@/components/Testimonials';
import Values from '@/components/Values';
import { CustomPage } from '@/types/pages';
import React from 'react';

export const componentSerializer = (page: CustomPage, props?: Record<string, unknown>): React.ReactElement[] =>
  (page.content || []).map((c) => {
    switch (c._type) {
      case 'header':
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return <Fold key={c._key} {...(c as any)} {...props} />;
      case 'body':
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return <Body key={c._key} {...(c as any)} {...props} />;
      case 'capabilities':
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return <Capabilities key={c._key} {...(c as any)} {...props} />;
      case 'imageWithText':
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return <FiftyFifty key={c._key} {...(c as any)} {...props} />;
      case 'ctaWithImage':
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return <Banner key={c._key} {...(c as any)} {...props} />;
      case 'talent':
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return <Talents key={c._key} {...(c as any)} {...props} />;
      case 'ctaBar':
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return <CTAList key={c._key} {...(c as any)} {...props} />;
      case 'quote':
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return <Testimonials key={c._key} {...(c as any)} {...props} />;
      case 'companyValuesList':
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return <Values key={c._key} {...(c as any)} {...props} />;
      case 'grid':
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return <Grid key={c._key} {...(c as any)} {...props} />;
      case 'collapsibleItems':
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return <CollapsibleItems key={c._key} {...(c as any)} {...props} />;
      case 'columnsLayout':
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return <ColumnsLayout key={c._key} {...(c as any)} {...props} />;
      case 'hubspotForm':
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return <HubspotFormBlock key={c._key} {...(c as any)} />;
      case 'flexRow':
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return <FlexRow key={c._key} {...(c as any)} {...props} />;
      case 'caseStudyTeam':
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return <CaseStudyTeam key={c._key} {...(c as any)} />;
      case 'logoBar':
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return <ClientLogoBar key={c._key} {...(c as any)} />;
      case 'caseStudyList':
        return null; // handled by dedicated index page
      default:
        return null;
    }
  });
